import {
    faAt,
    faCheck,
    faClock,
    faEdit,
    faPhone,
    faPlus,
    faSms,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Table from "../../../../Components/Table";
import { ListarEmailContaController } from "../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";

import {
    DeletarConfigReguaController,
    ListarConfigReguaController,
} from "../../../../Controllers/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaControllers";
import { ListarReguaController } from "../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IEmailConta } from "../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import { IConfigRegua } from "../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";
import { IRegua } from "../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import { AlertWarning } from "../../../../Tools/SweetAlerts";
import {
    CadastrarEditarConfigRegua,
    CadastrarEditarConfigReguaFooter,
    CadastrarEditarConfigReguaHeader,
} from "./EditarConfiguracaoDeRegua";
import ValidarSMS from "./ValidarSMS";

interface ListaConfigReguaComNomeRegua {
    ID_CASO_COBRANCA_REGUA_CONFIG: number;
    ID_CONTA_EMAIL_ENVIO: number;
    DS_EMAIL_RECEPTIVO_TESTE: string;
    NR_HORA_INICIAL: string;
    NR_HORA_FINAL: string;
    ID_SERVICO_SMS: number;
    DS_USUARIO_SMS: string;
    DS_SENHA_SMS: string;
    NR_TELEFONE_RECEPTIVO_TESTE: string;
    ID_CASO_COBRANCA_REGUA: number;
    DS_EMAIL_COPIA_OCULTA: string;
    DS_ID_AGRUPAMENTO: string;
    NR_MAX_EMAIL: number;
    NR_MAX_SMS: number;
    DS_NOME_REGUA: string;
}

export function ConfiguracaoDeRegua() {
    const [lstConfigRegua, setLstConfigRegua] = useState<Array<IConfigRegua>>(
        []
    );
    const [lstRegua, setLstRegua] = useState<Array<IRegua>>([]);
    const [lstEmails, setLstEmails] = useState<Array<IEmailConta>>([]);

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [emails, reguas] = await Promise.all([
                    ListarEmailContaController(),
                    ListarReguaController()
                ]);
                setLstEmails(emails);
                setLstRegua(reguas);
            } catch (error) {
                console.error('Erro ao carregar dados:', error);
            }
            updateList();
        };

        fetchData();
    }, []);

    const updateList = async () => {
        try {
            const configReguas = await ListarConfigReguaController();
            setLstConfigRegua(configReguas);
        } catch (error) {
            console.error('Erro ao atualizar lista de configurações de régua:', error);
        }
    };
    
    const adicionarNomeReguaNaConfigRegua = ():
        | ListaConfigReguaComNomeRegua[]
        | undefined => {
        if (lstRegua && lstConfigRegua) {
            let lstConfigReguaComNomeTemp: Array<ListaConfigReguaComNomeRegua> =
                [];

            lstConfigRegua.forEach((config) => {
                const regua = lstRegua?.find(
                    (regua) =>
                        regua.ID_CASO_COBRANCA_REGUA ===
                        config.ID_CASO_COBRANCA_REGUA
                )?.DS_NOME_REGUA;

                lstConfigReguaComNomeTemp.push({
                    ...config,
                    DS_NOME_REGUA: regua || "",
                } as ListaConfigReguaComNomeRegua);
            });

            return lstConfigReguaComNomeTemp;
        }
    };

    function row(cell: any, row: IConfigRegua) {
        const email = lstEmails?.find(
            (email) => email.ID_EMAIL_CONTA === row.ID_CONTA_EMAIL_ENVIO
        )?.DS_USERNAME;
        const regua = lstRegua?.find(
            (regua) =>
                regua.ID_CASO_COBRANCA_REGUA === row.ID_CASO_COBRANCA_REGUA
        )?.DS_NOME_REGUA;

        return (
            <div className="row m-0">
                <div className="col-12 d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex flex-column">
                        <h4 className="mb-0">{regua}</h4>
                    </div>
                    <div>
                        <span
                            className="label label-light-dark label-inline mr-3"
                            style={{ height: "auto" }}
                        >
                            <FontAwesomeIcon icon={faClock} className="mr-1" />{" "}
                            {row.NR_HORA_INICIAL} - {row.NR_HORA_FINAL}
                        </span>
                        <div
                            className="dropdown dropdown-inline"
                            data-toggle="tooltip"
                            title=""
                            data-placement="left"
                            data-original-title="Quick actions"
                        >
                            <a
                                href="#/"
                                className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                data-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="ki ki-bold-more-hor"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                                <ul className="navi navi-hover">
                                    <li
                                        className="navi-item"
                                        onClick={() => {
                                            setShow(true);
                                            setModal({
                                                Component: () =>
                                                    CadastrarEditarConfigRegua({
                                                        configRegua: row,
                                                        lstEmails:
                                                            lstEmails ? lstEmails : [],
                                                        lstRegua:
                                                            lstRegua ? lstRegua : [],
                                                        updateList,
                                                    }),
                                                footer: CadastrarEditarConfigReguaFooter(
                                                    "Atualizar"
                                                ),
                                                customHeader:
                                                    CadastrarEditarConfigReguaHeader(
                                                        "Atualizar"
                                                    ),
                                                size: "lg",
                                            });
                                        }}
                                    >
                                        <span className="navi-link">
                                            <span className="navi-icon">
                                                <FontAwesomeIcon
                                                    icon={faEdit}
                                                    className="text-primary"
                                                />
                                            </span>
                                            <span className="navi-text">
                                                Editar
                                            </span>
                                        </span>
                                    </li>
                                    <li className="navi-item">
                                        <span
                                            className="navi-link"
                                            onClick={() => {
                                                if (
                                                    row.DS_USUARIO_SMS &&
                                                    row.DS_SENHA_SMS &&
                                                    row.ID_SERVICO_SMS &&
                                                    (row.DS_ID_AGRUPAMENTO ||
                                                        row.ID_SERVICO_SMS !==
                                                            1)
                                                ) {
                                                    setModal({
                                                        Component: () => (
                                                            <ValidarSMS
                                                                {...row}
                                                                setShow={
                                                                    setShow
                                                                }
                                                            />
                                                        ),
                                                        headerComponent:
                                                            "Envio de SMS de teste",
                                                        IconHeader: faSms,
                                                    });
                                                    setShow(true);
                                                } else {
                                                    AlertWarning(
                                                        "Está configuração de régua não é válida para envio de SMS"
                                                    );
                                                }
                                            }}
                                        >
                                            <span className="navi-icon">
                                                <FontAwesomeIcon
                                                    icon={faCheck}
                                                    className="text-success"
                                                />
                                            </span>
                                            <span className="navi-text">
                                                Validar SMS
                                            </span>
                                        </span>
                                    </li>
                                    <li
                                        className="navi-item"
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Deseja apagar esta configuração de régua?",
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton:
                                                        "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    DeletarConfigReguaController(
                                                        row.ID_CASO_COBRANCA_REGUA_CONFIG
                                                    ).then(updateList);
                                                }
                                            });
                                        }}
                                    >
                                        <span className="navi-link">
                                            <span className="navi-icon">
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    className="text-danger"
                                                />
                                            </span>
                                            <span className="navi-text">
                                                Excluir
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="d-flex flex-wrap">
                        {email && (
                            <div className="label label-light-primary label-inline mr-2 my-1">
                                <FontAwesomeIcon icon={faAt} className="mr-2" />
                                {email}
                            </div>
                        )}
                        {row.NR_TELEFONE_RECEPTIVO_TESTE && (
                            <div className="label label-light-primary label-inline mr-2 my-1">
                                <FontAwesomeIcon
                                    icon={faPhone}
                                    className="mr-2"
                                />
                                {row.NR_TELEFONE_RECEPTIVO_TESTE}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME_REGUA",
            text: "Configurações de Régua",
            formatter: row,
        },
    ];

    return (
        <div className="card">
            <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
                <h3 className="card-title align-items-start flex-column mb-0">
                    <span className="card-label font-weight-bolder text-dark">
                        Configurações de Régua
                    </span>
                </h3>
                <div className="card-toolbar">
                    <button
                        className="btn btn-success font-weight-bold"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () =>
                                    CadastrarEditarConfigRegua({
                                        lstEmails: lstEmails || [],
                                        lstRegua: lstRegua || [],
                                        updateList,
                                        setShow,
                                    }),
                                footer: CadastrarEditarConfigReguaFooter(
                                    "Cadastrar"
                                ),
                                customHeader:
                                    CadastrarEditarConfigReguaHeader(
                                        "Cadastrar"
                                    ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Nova Configuração
                    </button>
                </div>
            </div>
            <div className="card-body">
                {lstConfigRegua && lstEmails && lstRegua && (
                    <Table
                        columns={columns}
                        data={
                            adicionarNomeReguaNaConfigRegua() || lstConfigRegua
                        }
                        keyField="ID_CASO_COBRANCA_REGUA_CONFIG"
                    />
                )}
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
